import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationDialog } from 'components/custom';
import { Delete } from '@mui/icons-material';
const DeletionConfirmationDialog = (props) => {
    const { cancelButtonProps, confirmButtonProps, titleProps, ...cmpProps } = props;
    return (_jsx(ConfirmationDialog, { titleProps: {
            Icon: Delete,
            color: 'error.main',
            ...titleProps,
        }, cancelButtonProps: cancelButtonProps, confirmButtonProps: {
            startIcon: _jsx(Delete, {}),
            ...confirmButtonProps,
        }, ...cmpProps }));
};
export default DeletionConfirmationDialog;
